export default __webpack_public_path__ + "static/media/lichtgestaltung-1.3a69d820.jpeg";